"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Settings = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M13.533 5.81c.079.117.211.19.354.19H14a2 2 0 1 1 0 4h-.057a.433.433 0 0 0-.397.263.434.434 0 0 0 .079.479l.04.04a2 2 0 1 1-2.83 2.83l-.035-.035a.436.436 0 0 0-.484-.084.432.432 0 0 0-.263.394V14a2 2 0 1 1-4 0 .466.466 0 0 0-.322-.457.431.431 0 0 0-.473.082l-.04.04a2 2 0 1 1-2.83-2.83l.035-.035a.436.436 0 0 0 .084-.484.432.432 0 0 0-.394-.263H2a2 2 0 1 1 0-4 .466.466 0 0 0 .457-.322.431.431 0 0 0-.082-.473l-.04-.04a2 2 0 1 1 2.83-2.83l.035.035a.433.433 0 0 0 .477.087.667.667 0 0 1 .133-.043.432.432 0 0 0 .19-.354V2a2 2 0 1 1 4 0v.057c0 .173.104.329.27.4a.431.431 0 0 0 .472-.082l.04-.04a2 2 0 1 1 2.83 2.83l-.035.035a.433.433 0 0 0-.087.477.667.667 0 0 1 .043.133zM8 10.667a2.667 2.667 0 1 0 0-5.334 2.667 2.667 0 0 0 0 5.334z"
}));

var _default = Settings;
exports.default = _default;